import {API, Setup} from '../../Services';

async function courier_orders_api(page){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.get(`/merchant_admin/${merchantId}/courier/orders?page=${page}`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function courierOrderUpdate_api(id){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.put(`/merchant_admin/${merchantId}/courier/orders/${id}`,{
        "status": 25
    },{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function checkCode_api(id,code){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.post(`/merchant_admin/${merchantId}/courier/orders/${id}/verify_code`,
        {"delivery_code": code}
        ,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function courierOrderAcceptOrder_api(id){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.post(`/merchant_admin/${merchantId}/courier/orders/${id}/accept`,{},{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function courierOrderRequestDeliveryCode_api(id){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.post(`/merchant_admin/${merchantId}/courier/orders/${id}/request_code`,{},{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}



async function courierOrderDetail_api(id){
    const token = localStorage.getItem("token");
    const merchantId = localStorage.getItem("merchantId");
    return API.get(`/merchant_admin/${merchantId}/courier/orders/${id}`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

export {
    courier_orders_api,
    courierOrderUpdate_api,
    courierOrderDetail_api,
    courierOrderAcceptOrder_api,
    courierOrderRequestDeliveryCode_api,
    checkCode_api
};
